import { AspNetRole } from '@/models/Enums';
import AssociationUserInfo from './AssociationUserInfo';

export default class UserInfo {
    public aspNetRole: AspNetRole = 0;
    public associationUserInfo: AssociationUserInfo | null = null;
    public name = "";
    public isAuthenticated = false;
    public token = "";
    public hasMultipleAssociationUsers = false;
}

